// extracted by mini-css-extract-plugin
export default {"section":"AddressInfo_section__5XWGr","selectContainer":"AddressInfo_selectContainer__mwRGw"};